import {useContext} from 'react';
import WidgetContext from './WidgetContext';
import CheckoutSummary from './CheckoutSummary';
import {calculateTotalCount} from './utils';
import {SvgShop} from "/components/shared/SvgIcons";

function TabItem({item, active, onSelect, children}) {
    return (
        <button onClick={() => onSelect(item)}
                className={`font-cooper-hewitt-medium block uppercase border-b-4  ${active ? 'border-b-gold' : 'border-b-transparent'} hover:border-b-gold text-[20px] my-6`}>
          {children ? children : item.name}
        </button>
    );
}

export default function ShopMenu({activeTab, setActiveTab}) {
    const {contingents, ticketing} = useContext(WidgetContext);
    const totalCount = calculateTotalCount(contingents);

    return (
        <>
          <div
            className="hidden md:flex flex-col w-1/4 pt-16 pb-8 justify-between items-center border-r border-r-blue-medium overflow-scroll">
            <div className="">
              <h2 className="text-xl font-bold mb-12">Der Shop</h2>
              <TabItem key="cart"
                       onSelect={item => setActiveTab("cart")}
                       active={activeTab === "cart"}
                       item={{}}>
                <div className="flex items-center justify-center pb-2">
                  {SvgShop("#000")}
                  <div className="ml-2 h-6">Warenkorb</div>
                  <div
                    className="ml-2 bg-gold rounded-full text-sm text-white font-bold w-6 h-6 flex items-center justify-center pt-1 ">{totalCount}</div>
                </div>
              </TabItem>

              {
                  ticketing.product_categories.map(item => (
                      <TabItem key={item.slug}
                               onSelect={item => setActiveTab(item.slug)}
                               active={activeTab === item.slug}
                               item={item}/>
                  ))
              }
            </div>
            <div className="p-8 rounded-lg p-6 bg-light_brown ">
              <CheckoutSummary emptyLabel="Produkte Wählen..."/>
            </div>
          </div>
          <div className="md:hidden py-2 px-8 rounded-lg p-6 bg-light_brown ">
            <CheckoutSummary emptyLabel="Produkte Wählen..."/>
          </div>
        </>
    );
}
